// function to append new Blackcart TBYB toggle copy
document.addEventListener("tbyb_cart_update", function () {
    var productId = tbyb.getSelectedVariants()?.productId
    if (productId) {
      var eligible = tbyb.viewManager.eligibilityService.getEligibilityStatus(productId)
      if (eligible.state) {
        if (document.querySelector("#toggle_deposit_text")) {
          return
        }
        var elem = document.querySelector("#blackcart_info")
        if (elem) {
          // get deposit
          var deposit = tbyb.validator.validatedCartInfo?.deposit
          if (deposit) {
            p = document.createElement("p");
            p.setAttribute("id", "toggle_deposit_text");
            p.innerHTML = 'Try for 100 nights.' + '&nbsp' + 'Payment won\'t be charged until 35 nights after delivery. Try with a $20 refundable deposit. ' +' &nbsp'
            elem.prepend(p)
          }
        }
      }
    }
})

document.addEventListener("tbyb_cart_update", function () {
  var productId = tbyb.getSelectedVariants()?.productId;
  if (productId) {
    var eligible = tbyb.viewManager.eligibilityService.getEligibilityStatus(productId);
    if (eligible.state) {
      var elem = document.querySelector(".bc-pay_option--label");
      if (elem) {
        if (!document.querySelector("#pay_today_text")) {        
          var priceElements = document.querySelectorAll(".tbyb-1izyex6");
          if (priceElements.length >= 2) {
            var priceElement = priceElements[1];
            var price = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ''));
            var monthlyInstallment = Math.floor((price * 0.09026217 * 100)) / 100;
            var p = document.createElement("div");
            p.setAttribute("class", "pay_today_text");
            p.setAttribute("id", "pay_today_text");
            p.innerHTML = 'Or pay monthly installments as low as $' + monthlyInstallment.toFixed(2) + '. Options available at checkout.';
            elem.append(p);
          }
        }
      }
    }
  }
});



// helper script for product options on PDP's 

$(document).ready(() => {
  document.querySelectorAll('div[class*="swatch-element"]').forEach(item => item.addEventListener('click', e => {
    if (e.target.value) {
      var selectedVariant = e.target.value;
      document.querySelector('select[id*="productSelect-template"]').options.forEach(option => {
        var innerHTML = option.innerHTML;
        if(innerHTML.substring(0, innerHTML.indexOf('-')).trim() == selectedVariant) {
          option.setAttribute('selected', 'selected');
        }
      });
    }
  }));
});

console.log('BLACKCART CUSTOM SCRIPT: blackcart-custom.js');
var script = document.querySelector('[data-tbyb="tbyb-script"]');
script.addEventListener('load', function () {
  if(tbyb){
    let interval = setInterval(function(){
      let learnMore = document.querySelector('[data-testid=blackcart-learn-more]');
      if(learnMore){
        learnMore.addEventListener("click", function(){tbyb.viewManager.showLearnMoreModal()});
        clearInterval(interval);
      }
    }, 1000);
  }
});

